// components/JobCard.jsx
import React from 'react';
import { FaRegBookmark } from 'react-icons/fa';
import { HiOutlineExternalLink } from 'react-icons/hi';

const JobCard = ({ title, company, location, type, method }) => {
  return (
    <div className="border-4 rounded-lg px-4 pt-4 pb-5 bg-white relative flex flex-col justify-between h-full">
      {/* Bookmark Icon */}
      <div className="absolute top-4 right-4 text-gray-400 hover:text-black cursor-pointer">
        <FaRegBookmark size={16} />
      </div>

      {/* Placeholder for logo */}
      <div className="h-6 w-16 mb-3 bg-gray-200 rounded-sm"></div>

      {/* Job Info */}
      <div>
        <h3 className="text-xl font-semibold text-black leading-snug mb-1">{title}</h3>
        <p className="font-semibold text-gray-700 leading-tight mb-0.5">{company}</p>
        <p className="font-semibold text-gray-700 leading-tight mb-2">{location}</p>
        {type && <p className="text-xs text-gray-500 mb-3">{type}</p>}
      </div>

      {/* Apply Button */}
      <div className="mt-32">
        <button className="border-black border-2 w-full py-2 rounded text-sm font-semibold flex justify-center items-center gap-2 hover:bg-gray-50">
          {method === 'quick' ? 'Quick Apply' : (
            <>
              Apply <HiOutlineExternalLink className="text-xs" />
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default JobCard;
